import get from "lodash/get";
import { getFlagValue } from "../utils/FeatureHelper";
import { hasBannerFreeCredit, hasBannerFreeAmount } from "../constants";

export function getCurrency() {
  return localStorage.getItem("currency") || "";
}

export const FC_MAPPING = {
  IDR: {
    currency: "Rp",
    amount: {
      1: '100,000',
    }
  },
  MYR: {
    currency: "RM",
    amount: {
      1: '150',
    }
  },
  PHP: {
    currency: "₱",
    amount: {
      1: '2,500',
    }
  },
  SGD: {
    currency: "S$",
    amount: {
      1: '190',
    }
  },
  THB: {
    currency: "฿",
    amount: {
      1: '770',
    }
  },
  VND: {
    currency: "₫",
    amount: {
      1: '520,000',
    }
  },
};

export function getFreeCreditInfo() {
  const currency = getCurrency();
  const flagVal = getFlagValue(hasBannerFreeCredit);
  const fcAmount = getFlagValue(hasBannerFreeAmount);
  return {
    currency: get(fcAmount, `${currency}.currency`, ''),
    amount: get(fcAmount, `${currency}.amount.${flagVal}`, '')
  }
}